import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { SubAssembly } from "../../../../types/subAssembly";
import { formatSubAssemblyDisplayLabel, isAttachedSubAssembly } from "../../../../utils/subAssemblyUtils";

type Props = {
  componentId: string;
  subAssemblies: SubAssembly[];
};

export function AttachedLandingGearSubAssemblies({ componentId, subAssemblies }: Readonly<Props>) {
  const items = useMemo(
    () =>
      componentId
        ? subAssemblies.filter(
            (item) => item.componentId === componentId && isAttachedSubAssembly(item)
          )
        : [],
    [subAssemblies, componentId]
  );

  if (items.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 1,
        ml: 0.5,
        pl: 1.5,
        borderLeft: "2px solid hsl(19 101% 51% / 0.3)",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {items.map((item) => (
        <Typography
          key={item.id}
          sx={{ color: "#fff", fontSize: "0.85rem", lineHeight: 1.5 }}
        >
          {formatSubAssemblyDisplayLabel(item)}
        </Typography>
      ))}
    </Box>
  );
}
